import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/“.svg';
import _imports_1 from '@/assets/imgs/about/mission.webp';
const _withScopeId = n => (_pushScopeId("data-v-276ed511"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "about wrap-dec"
};
const _hoisted_2 = {
  class: "container mx-a px-5"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  class: "top flex gap-[42px] flex-col lg:flex-row mb-[150px]"
};
const _hoisted_5 = {
  class: "flex items-start top-shadow rounded-2xl py-[33px] pl-[22px] pr-[38px] flex-1"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "text-[40px] font-medium mb-4 leading-[46px]"
};
const _hoisted_8 = {
  class: "text-[#3d4555] text-[15px] leading-[26px]"
};
const _hoisted_9 = {
  class: "text-5xl text-center font-medium mb-20"
};
const _hoisted_10 = {
  class: "desc flex flex-col md:flex-row mb-[140px] rounded-2xl overflow-hidden"
};
const _hoisted_11 = {
  class: "flex flex-1 justify-center bg-[#333] relative"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "absolute top-[70px] left-[68px] w-[47px]"
}, null, -1));
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-[460px] object-cover",
  src: _imports_1,
  alt: "about"
}, null, -1));
import { useI18n } from "vue-i18n";
import QA from "@/components/QA.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'AboutView',
  setup(__props) {
    const {
      t
    } = useI18n();
    const topList = ["time", "user", "asset"];
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h2", {
        class: "text-[56px] font-medium text-center mx-auto mt-[150px] mb-20 leading-[72px]",
        innerHTML: _unref(t)(`about.title`)
      }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(topList, item => {
        return _createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
          class: "w-[44px] mr-3",
          src: require(`@/assets/imgs/about/${item}.png`),
          alt: ""
        }, null, 8, _hoisted_6), _createElementVNode("div", null, [_createElementVNode("h4", _hoisted_7, _toDisplayString(_unref(t)(`about.info.${item}.title`)), 1), _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)(`about.info.${item}.content`)), 1)])]);
      }), 64))]), _createElementVNode("h3", _hoisted_9, _toDisplayString(_unref(t)(`about.mission.title`)), 1), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("p", {
        class: "text-[24px] leading-[48px] mt-[106px] ml-20 mb-10 text-white",
        innerHTML: _unref(t)(`about.mission.content`)
      }, null, 8, _hoisted_13)]), _hoisted_14])]), _createVNode(QA, {
        name: "about",
        length: 4
      })]);
    };
  }
});